import { supabase } from "@/integrations/supabase/client";

export interface LawyerProfile {
  id: string;
  firm_id: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
}

export interface EnsureLawyerProfileResult {
  success: boolean;
  lawyer?: LawyerProfile;
  created?: boolean;
  error?: string;
}

export async function ensureLawyerProfile(): Promise<EnsureLawyerProfileResult> {
  try {
    const { data, error } = await supabase.functions.invoke('ensure-lawyer-profile', {
      body: {}
    });

    if (error) {
      console.error('Error ensuring lawyer profile:', error);
      return {
        success: false,
        error: error.message || 'Failed to ensure lawyer profile'
      };
    }

    return data as EnsureLawyerProfileResult;
  } catch (error) {
    console.error('Exception in ensureLawyerProfile:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred'
    };
  }
}